import { useState, useEffect } from 'react';
import api from '../../services/api';

export default function Funcionarios() {
  const [funcs, setFuncs] = useState([]);
  const [filtroTipo, setFiltroTipo] = useState('todos');
  const [editando, setEditando] = useState(null);
  const [novo, setNovo] = useState({
    nome: '', email: '', telefone: '', senha: '',
    tipo: 'atendente', taxa_entrega_padrao: '', ativo: 1
  });
  const [mostrarForm, setMostrarForm] = useState(false);
  const [toast, setToast] = useState('');

  const showToast = (msg) => {
    setToast(msg);
    setTimeout(() => setToast(''), 2500);
  };

  const carregar = async () => {
    try {
      const r = await api.get('/funcionarios');
      setFuncs(r.data);
    } catch { showToast('❌ Erro ao carregar'); }
  };

  useEffect(() => { carregar(); }, []);

  const salvarNovo = async () => {
    if (!novo.nome || !novo.email || !novo.senha) {
      return showToast('⚠️ Nome, email e senha obrigatórios');
    }
    try {
      await api.post('/funcionarios', {
        ...novo,
        taxa_entrega_padrao: parseFloat(novo.taxa_entrega_padrao) || 0
      });
      setNovo({ nome: '', email: '', telefone: '', senha: '', tipo: 'atendente', taxa_entrega_padrao: '', ativo: 1 });
      setMostrarForm(false);
      showToast('✅ Funcionário cadastrado!');
      carregar();
    } catch (e) { showToast(e.response?.data?.error || '❌ Erro'); }
  };

  const salvarEdicao = async () => {
    try {
      const dados = {
        nome: editando.nome,
        email: editando.email,
        telefone: editando.telefone,
        tipo: editando.tipo,
        taxa_entrega_padrao: parseFloat(editando.taxa_entrega_padrao) || 0,
        ativo: editando.ativo
      };
      if (editando.nova_senha) dados.senha = editando.nova_senha;
      await api.put(`/funcionarios/${editando.id}`, dados);
      setEditando(null);
      showToast('✅ Atualizado!');
      carregar();
    } catch (e) { showToast(e.response?.data?.error || '❌ Erro'); }
  };

  const desativar = async (f) => {
    if (!window.confirm(`Desativar "${f.nome}"?`)) return;
    try {
      await api.delete(`/funcionarios/${f.id}`);
      showToast('✅ Desativado');
      carregar();
    } catch { showToast('❌ Erro'); }
  };

  const funcsFiltrados = funcs.filter(f =>
    filtroTipo === 'todos' || f.tipo === filtroTipo ||
    (filtroTipo !== 'todos' && f.tipo === 'ambos')
  );

  const tipoLabel = (t) => ({
    atendente: '🧑‍🍳 Atendente',
    entregador: '🛵 Entregador',
    ambos: '👥 Ambos'
  }[t] || t);

  const inputStyle = {
    background: 'var(--bg4)', border: '1px solid var(--border)',
    color: 'var(--text)', padding: '8px 10px', borderRadius: 6,
    fontSize: 13, width: '100%'
  };

  const btnStyle = {
    background: 'var(--orange)', border: 'none', color: '#fff',
    padding: '8px 14px', borderRadius: 6, cursor: 'pointer',
    fontSize: 13, fontWeight: 600
  };

  return (
    <div style={{ padding: 16, maxWidth: 900, margin: '0 auto' }}>
      {toast && <div style={{
        position: 'fixed', top: 60, left: '50%', transform: 'translateX(-50%)',
        background: 'linear-gradient(90deg,var(--red),var(--orange))',
        color: '#fff', padding: '10px 20px', borderRadius: 20,
        fontSize: 13, fontWeight: 700, zIndex: 999
      }}>{toast}</div>}

      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
        <h1 style={{ fontSize: 22, fontWeight: 800 }}>👥 Funcionários</h1>
        <button onClick={() => setMostrarForm(!mostrarForm)} style={btnStyle}>
          {mostrarForm ? '✕ Fechar' : '+ Novo'}
        </button>
      </div>

      {/* Filtros */}
      <div style={{ display: 'flex', gap: 8, marginBottom: 16, flexWrap: 'wrap' }}>
        {['todos', 'atendente', 'entregador'].map(t => (
          <button key={t} onClick={() => setFiltroTipo(t)} style={{
            ...btnStyle,
            background: filtroTipo === t ? 'var(--orange)' : 'var(--bg3)',
            fontSize: 12
          }}>
            {t === 'todos' ? 'Todos' : tipoLabel(t)}
          </button>
        ))}
      </div>

      {/* Form novo */}
      {mostrarForm && (
        <div style={{ background: 'var(--bg3)', padding: 16, borderRadius: 8, marginBottom: 16, border: '1px solid var(--border)' }}>
          <h3 style={{ marginBottom: 12, fontSize: 15 }}>Novo Funcionário</h3>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 10 }}>
            <input placeholder="Nome *" value={novo.nome} onChange={e => setNovo({ ...novo, nome: e.target.value })} style={inputStyle} />
            <input placeholder="Email *" type="email" value={novo.email} onChange={e => setNovo({ ...novo, email: e.target.value })} style={inputStyle} />
            <input placeholder="Telefone" value={novo.telefone} onChange={e => setNovo({ ...novo, telefone: e.target.value })} style={inputStyle} />
            <input placeholder="Senha *" type="password" value={novo.senha} onChange={e => setNovo({ ...novo, senha: e.target.value })} style={inputStyle} />
            <select value={novo.tipo} onChange={e => setNovo({ ...novo, tipo: e.target.value })} style={inputStyle}>
              <option value="atendente">🧑‍🍳 Atendente</option>
              <option value="entregador">🛵 Entregador</option>
              <option value="ambos">👥 Ambos</option>
            </select>
            {(novo.tipo === 'entregador' || novo.tipo === 'ambos') && (
              <input placeholder="Taxa padrão (R$)" type="number" step="0.01" value={novo.taxa_entrega_padrao} onChange={e => setNovo({ ...novo, taxa_entrega_padrao: e.target.value })} style={inputStyle} />
            )}
          </div>
          <button onClick={salvarNovo} style={{ ...btnStyle, width: '100%' }}>💾 Cadastrar</button>
        </div>
      )}

      {/* Lista */}
      {funcsFiltrados.length === 0 ? (
        <div style={{ textAlign: 'center', padding: 40, color: 'var(--text2)' }}>
          Nenhum funcionário cadastrado
        </div>
      ) : (
        funcsFiltrados.map(f => (
          <div key={f.id} style={{
            background: 'var(--bg3)', padding: 14, borderRadius: 8,
            marginBottom: 10, border: '1px solid var(--border)',
            opacity: f.ativo ? 1 : 0.5
          }}>
            {editando?.id === f.id ? (
              <div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 10 }}>
                  <input value={editando.nome} onChange={e => setEditando({ ...editando, nome: e.target.value })} style={inputStyle} placeholder="Nome" />
                  <input value={editando.email} onChange={e => setEditando({ ...editando, email: e.target.value })} style={inputStyle} placeholder="Email" />
                  <input value={editando.telefone || ''} onChange={e => setEditando({ ...editando, telefone: e.target.value })} style={inputStyle} placeholder="Telefone" />
                  <input type="password" value={editando.nova_senha || ''} onChange={e => setEditando({ ...editando, nova_senha: e.target.value })} style={inputStyle} placeholder="Nova senha (opcional)" />
                  <select value={editando.tipo} onChange={e => setEditando({ ...editando, tipo: e.target.value })} style={inputStyle}>
                    <option value="atendente">🧑‍🍳 Atendente</option>
                    <option value="entregador">🛵 Entregador</option>
                    <option value="ambos">👥 Ambos</option>
                  </select>
                  {(editando.tipo === 'entregador' || editando.tipo === 'ambos') && (
                    <input type="number" step="0.01" value={editando.taxa_entrega_padrao || ''} onChange={e => setEditando({ ...editando, taxa_entrega_padrao: e.target.value })} style={inputStyle} placeholder="Taxa" />
                  )}
                </div>
                <label style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 10, fontSize: 13 }}>
                  <input type="checkbox" checked={!!editando.ativo} onChange={e => setEditando({ ...editando, ativo: e.target.checked ? 1 : 0 })} />
                  Ativo
                </label>
                <div style={{ display: 'flex', gap: 8 }}>
                  <button onClick={salvarEdicao} style={{ ...btnStyle, background: 'var(--green, #22c55e)' }}>💾 Salvar</button>
                  <button onClick={() => setEditando(null)} style={{ ...btnStyle, background: 'var(--bg4)' }}>Cancelar</button>
                </div>
              </div>
            ) : (
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 10 }}>
                <div>
                  <div style={{ fontSize: 15, fontWeight: 700 }}>{f.nome} {!f.ativo && '(inativo)'}</div>
                  <div style={{ fontSize: 12, color: 'var(--text2)', marginTop: 2 }}>
                    {tipoLabel(f.tipo)} • {f.email}
                    {f.telefone && ` • ${f.telefone}`}
                    {(f.tipo === 'entregador' || f.tipo === 'ambos') && f.taxa_entrega_padrao > 0 && ` • Taxa: R$ ${parseFloat(f.taxa_entrega_padrao).toFixed(2)}`}
                  </div>
                </div>
                <div style={{ display: 'flex', gap: 6 }}>
                  <button onClick={() => setEditando({ ...f })} style={{ ...btnStyle, fontSize: 12, padding: '6px 10px' }}>✏️</button>
                  {f.ativo === 1 && (
                    <button onClick={() => desativar(f)} style={{ ...btnStyle, background: 'var(--red)', fontSize: 12, padding: '6px 10px' }}>🚫</button>
                  )}
                </div>
              </div>
            )}
          </div>
        ))
      )}
    </div>
  );
}
